import script from "./CompanyBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyBanner.vue?vue&type=script&setup=true&lang=js"

import "./CompanyBanner.vue?vue&type=style&index=0&id=7e6f992e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e6f992e"]])

export default __exports__